<!--  -->
<template>
<div class='sceneiframe' id="sceneiframe">
    <iframe allow="fullscreen" :src="`${link}`" ></iframe>
    <bar :active='-1' v-show="isShow"></bar>
</div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import bar from '../layout/sidebar.vue'
export default {
//import引入的组件需要注入到对象中才能使用
components: {
    bar:bar
},
data() {
//这里存放数据
return {
    isShow:true,
    link:'',
    fullscreen:false
};
},
//监听属性 类似于data概念
computed: {},
//监控data中的数据变化
watch: {},
//方法集合
methods: {
    screen() {
        
        // let element = document.documentElement;//设置后就是我们平时的整个页面全屏效果
        let element = document.getElementById('sceneiframe');//设置后就是   id==con_lf_top_div 的容器全屏
          if (this.fullscreen) {
            if (document.exitFullscreen) {
              document.exitFullscreen();
            } else if (document.webkitCancelFullScreen) {
              document.webkitCancelFullScreen();
            } else if (document.mozCancelFullScreen) {
              document.mozCancelFullScreen();
            } else if (document.msExitFullscreen) {
              document.msExitFullscreen();
            }
          } else {
            if (element.requestFullscreen) {
              element.requestFullscreen();
            } else if (element.webkitRequestFullScreen) {
              element.webkitRequestFullScreen();
            } else if (element.mozRequestFullScreen) {
              element.mozRequestFullScreen();
            } else if (element.msRequestFullscreen) {
             element.msRequestFullscreen();
            }
          }
          this.fullscreen = !this.fullscreen;
        
    }
},
//生命周期 - 创建完成（可以访问当前this实例）
created() {
    
},
//生命周期 - 挂载完成（可以访问DOM元素）
mounted() {
    this.link = "https://rjbwg.4dage.com/web/SuperTwo/index.html?m="+this.$route.query.id;
   // this.link = "SuperTwo/index.html?m="+this.$route.query.id;
   window.addEventListener('message', (e) => {
                if(e.data=='closeinfo'){
                    this.isShow = false;
                }
                if(e.data=='showinfo'){
                    this.isShow = true;
                }
                
            })
},
beforeCreate() {}, //生命周期 - 创建之前
beforeMount() {}, //生命周期 - 挂载之前
beforeUpdate() {}, //生命周期 - 更新之前
updated() {}, //生命周期 - 更新之后
beforeDestroy() {}, //生命周期 - 销毁之前
destroyed() {}, //生命周期 - 销毁完成
activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
}
</script>
<style lang='less' scoped>
//@import url(); 引入公共css类
    .sceneiframe {
        width:100%;
        height:100%;
        iframe {
            width:100%;
            height:100%;
        }
        .top-icons {
            position: absolute;
            top: 1.5625vw;
            left: 1.5625vw;
            display: flex;
            justify-content: center;
            .icon {
                width: 2.08vw;
                &.back {
                margin-right: 1vw;
                }
            }
        }
        
    }
@media screen and (max-width:600px) {
    .sceneiframe {
        .top-icons {
            top: 6.67vw;
            left: 4vw;
            .icon {
                width:10.6vw;
                &.back {
                    margin-right:2vw;
                }
            }
        }
    }
}
</style>